import React from 'react'
import { hasErrors, UseForm } from '../../../../hooks/use-form'
import { validateProfileInfo } from './profile-component.constants'
import { Avatar, Button, FilledInput, Grid, TextField } from '@material-ui/core'
import { AddAPhoto } from '@material-ui/icons'
import { ProfileComponentProps } from './profile-component.models'
import { useProfileComponent } from './profile-component.hook'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { useAppDialog } from '../../../../hooks/use-app-dialog'
import {AppDialogVariants} from '../../../../store/app-dialog/types'
import {useTranslation} from 'react-i18next'
import {useProfileComponentStyles} from './profile-component.styles'

export const ProfileComponent: React.FC<ProfileComponentProps> = (
  props: ProfileComponentProps
): React.ReactElement => {
  const {
    initialState,
    updateUserInfoAction,
    accountFormState,
    setNonUpdated,
  } = props
  const { t } = useTranslation()
  const { setAppDialog, setIsShow } = useAppDialog()
  const { updateUserInfoActionHandler, formValueChanges, createAvatar, deleteAvatar, imgUrl } = useProfileComponent(
    {
      updateUserInfoAction,
      accountFormState,
      setNonUpdated,
    }
  )

  const continueHandler = () => {
    deleteAvatar()
    setIsShow(false)
  }

  const confirmDeleteAvatar = () => {
    setAppDialog({
      variant: AppDialogVariants.warning,
      isShow: true,
      title: t('accountSettings.security.deleteAvatar.title'),
      message: t('accountSettings.security.deleteAvatar.message'),
      actions: (
        <>
          <Button onClick={continueHandler} variant='outlined'  color="primary">{t('accountSettings.security.deleteAvatar.ok')}</Button>
          <Button onClick={() => setIsShow(false)} color="primary" variant='contained'>
            {t('accountSettings.security.deleteAvatar.cancel')}
          </Button>
        </>
      )
    })
  }

  const { isSubmitting, nonUpdated } = accountFormState
  const classes = useProfileComponentStyles()
  return (
    <UseForm
      //@ts-ignore
      initialValues={initialState}
      validate={validateProfileInfo}
      onSubmit={updateUserInfoActionHandler}
      formValueChanges={formValueChanges}
    >
      {({ errors, inputHandlers, form, values, handleSubmit }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} md={8} lg={6}>
              <div className={classes.avatarHolder}>
                {imgUrl && <span className={classes.removeHolder} onClick={() => {
                  confirmDeleteAvatar()
                }}>
                  <HighlightOffIcon />
                </span>}
                <FilledInput
                  className={classes.fileInput}
                  type="file"
                  name="avatar"
                  id="avatar-file-input"
                  {...inputHandlers}
                  onChange={(event)=> {
                    createAvatar(event)
                  }}
                />
                <label
                  htmlFor="avatar-file-input"
                  className={classes.labelFileInput}
                >
                  <Avatar src={imgUrl} className={classes.avatar} />
                  <div className={classes.choosingBlock}>
                    <AddAPhoto />
                  </div>
                </label>
              </div>
              <TextField
                inputProps={{ 'data-testid': 'name' }}
                error={!!errors?.name}
                name="name"
                value={values.name}
                fullWidth
                variant="outlined"
                required
                label="Name"
                helperText={form.name.dirty && errors.name}
                className={classes.textItem}
                {...inputHandlers}
                onFocus={() => {
                  return
                }}
                onBlur={() => {
                  return
                }}
              />
              <div>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  // disabled={hasErrors(errors) || isSubmitting || !dirty}
                  disabled={hasErrors(errors) || isSubmitting || !nonUpdated}
                >
                  {isSubmitting ? 'Wait...' : 'Save changes'}
                </Button>
                {/*TODO us translation hook*/}
              </div>
            </Grid>
          </Grid>
        </form>
      )}
    </UseForm>
  )
}
